import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';

interface ContactMenuProps {
  type: 'email' | 'phone';
  value: string;
  Icon: React.ReactNode;
}

const ContactMenu: React.FC<ContactMenuProps> = ({ type, value, Icon }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const href =
    type === 'email'
      ? `https://mail.google.com/mail/?view=cm&fs=1&to=${value}`
      : `tel:${value}`;

  return (
    <>
      <Tooltip title={type === 'email' ? 'Email' : 'Phone'}>
        <IconButton onClick={handleClick}>{Icon}</IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MenuItem onClick={handleClose} component="a" href={href} target="_blank">
          {value}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ContactMenu;
